const CDN_URL = 'https://assets.revolut.com/media/'

export function cdnLink(name: string) {
  return `${CDN_URL}${name}`
}
